export const rootURL = location.origin + location.pathname;

export const ShowLoadingPane = function (self, show) {
    self.$emit('showLoading', show);
}